export default __webpack_public_path__ + "static/media/New_Application-white.0394ad0a.svg";